export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40022b520276baab3a2bed1c8212282a13a0dfa2b4&name=revalidateCommunity!'